import * as api from '@/http'

export const ActionSetMovements = async ({ commit }) => {
  const movements = await api.http.get('dash/movements').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_movements', movements)
}

export const ActionSetMovementTypes = async ({ commit }) => {
  const movement_types = await api.http.get('dash/movements/types').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_movementTypes', movement_types)
}

export const ActionStoreMovement = async ({ commit }, data) => {
  const movement = await api.http.post('dash/movements', data).then((response) => response.body)
  commit('SET_movements', movement)
}

export const ActionUpdateMovement = async ({ commit }, payload) => {
  const movement = await api.http
    .post(`dash/movements/${payload.id}`, payload.form_data)
    .then((response) => response.body)
  commit('SET_movements', movement)
}

export const ActionDeleteMovement = async ({ commit }, payload) => {
  const movement = await api.http
    .put(`dash/movements/delete/${payload}`, payload)
    .then((response) => response.body)
  commit('SET_movements', movement)
}

export const ActionStoreTransferDocument = async ({ commit }, payload) => {
  const movement = await api.http
    .post(`dash/movements/upload/${payload.id}`, payload.form_data)
    .then((response) => response.body)
  commit('SET_movements', movement)
}
